var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLine = function SvgLine(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 8,
    fill: "#0EA400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9554 23.0843C38.0254 22.7143 38.06 22.403 38.0764 22.1591C38.1024 21.7562 38.073 21.1579 38.0618 20.9711C37.6908 14.5172 30.9948 9.375 22.7891 9.375C14.3447 9.375 7.5 14.8198 7.5 21.5357C7.5 27.7095 13.2829 32.8084 20.7753 33.5927C21.2327 33.6402 21.563 34.0535 21.5128 34.5118L21.1938 37.3825C21.1211 38.0345 21.7947 38.5083 22.3853 38.2238C28.7155 35.169 32.5002 32.0259 34.7604 29.303C35.172 28.8076 36.5131 26.9287 36.7864 26.4349C37.3674 25.387 37.7669 24.262 37.9554 23.0843",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 23.9996V18.8773C14.4001 18.4449 14.0499 18.0947 13.6185 18.0947C13.1861 18.0947 12.8359 18.4449 12.8359 18.8773V24.7812C12.8359 25.2136 13.1861 25.5637 13.6185 25.5637H16.746C17.1783 25.5637 17.5285 25.2136 17.5285 24.7812C17.5285 24.3497 17.1783 23.9996 16.746 23.9996H14.4001Z",
    fill: "#0EA400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2263 25.5637H18.8848C18.5467 25.5637 18.2734 25.2905 18.2734 24.9524V18.706C18.2734 18.3688 18.5467 18.0947 18.8848 18.0947H19.2263C19.5635 18.0947 19.8376 18.3688 19.8376 18.706V24.9524C19.8376 25.2905 19.5635 25.5637 19.2263 25.5637",
    fill: "#0EA400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5439 18.877V22.4844C25.5439 22.4844 22.4207 18.4101 22.3731 18.3565C22.2235 18.1896 22.0039 18.0858 21.7592 18.0953C21.3338 18.1118 21.0078 18.4836 21.0078 18.909V24.7818C21.0078 25.2133 21.358 25.5635 21.7903 25.5635C22.2218 25.5635 22.572 25.2133 22.572 24.7818V21.196C22.572 21.196 25.7427 25.3058 25.7894 25.3499C25.9278 25.4805 26.1137 25.5618 26.3186 25.5635C26.7527 25.5678 27.1081 25.183 27.1081 24.749V18.877C27.1081 18.4447 26.7579 18.0953 26.3255 18.0953C25.8941 18.0953 25.5439 18.4447 25.5439 18.877",
    fill: "#0EA400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9738 18.8769V18.8769C32.9738 18.4445 32.6236 18.0952 32.1913 18.0952H29.0629C28.6314 18.0952 28.2812 18.4445 28.2812 18.8769V24.7817C28.2812 25.2132 28.6314 25.5634 29.0629 25.5634H32.1913C32.6236 25.5634 32.9738 25.2132 32.9738 24.7817C32.9738 24.3494 32.6236 23.9992 32.1913 23.9992H29.8454V22.6114H32.1913C32.6236 22.6114 32.9738 22.2612 32.9738 21.8289C32.9738 21.3974 32.6236 21.0472 32.1913 21.0472H29.8454V19.6585H32.1913C32.6236 19.6585 32.9738 19.3092 32.9738 18.8769",
    fill: "#0EA400"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLine);
export default ForwardRef;